(ns hai.ui.components.form.select.common
  (:require
   ["react" :as react]
   [lambdaisland.ornament :refer [defstyled]]))

;;;
;;; Options
;;;

;; TODO these styles are not isolated from browser extension, they are visually broken when not used
;; withing the extension
(defstyled options-styled :div
  :absolute
  {:background-color "white"
   :top "100%"
   :margin-top "2px"
   :max-height "480px"
   :overflow-y "auto"
   :width "100%"
   :z-index "100"})

;; TODO these styles are not isolated from browser extension, they are visually broken when not used
;; withing the extension
(defstyled option-styled :div
  :cursor-pointer
  :border
  :border-gray-200
  {:border-bottom {:width "0"}
   :border-top {:width "0"}}
  [:>div
   :py-2
   :px-4
   ;; keeps the space needed for the border so that the text does not jump
   ;; around; the issue is that the border on non-hovered elements is
   ;; 1px but the border on the hovered elements is 2px
   {:border-left {:width "1px"
                  :color "transparent"
                  :style "solid"}
    :display "flex"
    :align-items "center"
    :gap "7px"
    :justify-content "start"}]
  [:&:first-child
   {:border-top {:width "1px"}
    :border-top-left-radius "4px"
    :border-top-right-radius "4px"}]
  [:&:last-child
   {:border-bottom-left-radius "4px"
    :border-bottom-right-radius "4px"
    :border-bottom {:width "1px"}}]
  [:&.active {:background-color "#F1F9FF"
              :border-left-color "#3563FA"}])

;;
;; Interactions
;;

;; TODO copied from shelf... sort out... eventually
(defn on-click-out
  [ref body-on-click-handler]
  (let [handler (fn [event]
                  (assert (.-current ref))
                  (let [dom-node (first (.. event composedPath))]
                    ;; A handler that already dealt with this click calls
                    ;; `preventDefault` (e.g. a disabled dropdown option that
                    ;; must not dismiss the popover). React's `stopPropagation`
                    ;; can't stop this native document-level listener, but the
                    ;; shared native event's `defaultPrevented` flag is readable
                    ;; here -- treat it as "handled inside", not an outside click.
                    (when (and (not (.-defaultPrevented event))
                               (not (.contains (.-current ref) dom-node)))
                      (body-on-click-handler))))]
    (react/useEffect
     (fn []
       (-> (.-body js/document)
           (.addEventListener "click" handler))
       (fn []
         (some-> (.-body js/document)
                 (.removeEventListener "click" handler))))
     #js[])))
